import { createSlice, PayloadAction, createAsyncThunk, Action } from '@reduxjs/toolkit';
import { getFilters } from './api';
import { FiltersSliceState, FilterParameter, FilterValuesObj } from './interfaces';
import { prepareFilterValues } from './utils';

const initialState: FiltersSliceState = {
  isFiltersLoading: 'idle',
  filtersStructure: [],
  filtersValue: {},
};

export const fetchFilters = createAsyncThunk('filters/fetchFilters', async () => {
  const response = await getFilters();

  return response.data;
});

const filtersSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    updateFilters: (state: FiltersSliceState, action: PayloadAction<FilterParameter>) => {
      const { key, newValue } = action.payload;

      state.filtersValue = { ...state.filtersValue, [key]: newValue };
    },
    getFiltersValueFromURL: (state: FiltersSliceState, action: PayloadAction<FilterValuesObj[]>) => {
      const infoFromURL = action.payload;
      const filtersValueFromUrl = infoFromURL.reduce((current, next) => {
        return {
          ...current,
          ...next,
        };
      }, {});
      state.filtersValue = filtersValueFromUrl;
    },
    resetFilters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilters.pending, (state) => {
        state.isFiltersLoading = 'pending';
      })
      .addCase(fetchFilters.fulfilled, (state, action) => {
        state.isFiltersLoading = 'success';
        const backendFilters = action.payload;

        if (Object.keys(state.filtersValue).length === 0) {
          state.filtersValue = prepareFilterValues({ filters: backendFilters }).reduce((current, next) => {
            return { ...current, ...next };
          }, {});
        }

        const uniqueFilters = new Set(backendFilters);
        state.filtersStructure = Array.from(uniqueFilters).sort((a, b) => a.sort - b.sort);
      })
      .addCase(fetchFilters.rejected, (state) => {
        state.isFiltersLoading = 'error';
      });
  },
});

export const { updateFilters, resetFilters, getFiltersValueFromURL } = filtersSlice.actions;
export default filtersSlice.reducer;
